import React from 'react';
import S from './Input.module.css';
import iconSrch from '../../assets/images/support/iconSrch.png';

const SearchInput = ({ options = [], ...props }) => {
  return (
    <>
      <select className={S[props.selectclass]} value={props.selectvalue} name={props.selectname} onChange={props.onChange}>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <input
        {...props}
        className={S[props.inputclass]}
      />
      <img src={iconSrch} alt='srch'></img>
    </>
  );
};

export default SearchInput;